/* KORE Private Home — lo propio de «Tiendas dedicadas»
   (sections/kore-private-home.liquid).

   El movimiento del objeto (entrada, inclinación, enderezarse al acercar el
   ratón) lo pone el motor compartido assets/kore-stage3d.js. Aquí:

   1. Cambiar de club. La ventana pasa por las tiendas elegidas: la URL se
      reescribe letra a letra, los colores del resplandor viajan de un club
      al otro y la portada se recompone por partes (eso último es CSS).
   2. Paso automático, para que se entienda sin tocar nada: una vuelta y se
      para. Solo con la sección en pantalla y sin el ratón encima; con
      movimiento reducido, nunca. Tocar un club lo detiene.
   3. La cuenta atrás de las tiendas abiertas, contra el mismo instante de
      cierre que la tienda real (kore-campaign-cierre, 23:59 de Madrid).
   4. Cada ventaja de la izquierda ilumina su pieza. La de diseño, además,
      va pasando de club mientras se mira. */
(function () {
  'use strict';
  if (window.KorePrivateHome) return;
  window.KorePrivateHome = true;

  /* Textos en el idioma de la visita (snippets/kore-i18n-js); sin él, español. */
  var T = window.KoreI18n || {};
  function t(k, es) { return T[k] || es; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CADENCIA = 5600;   // ms por club en el paso automático
  var CADENCIA_FOCO = 2400;
  var TECLA = 26;        // ms por letra de la URL

  function dos(n) { return (n < 10 ? '0' : '') + n; }

  /* El mismo texto que la cuenta atrás de la tienda real. */
  function formatoTienda(ms) {
    if (ms <= 0) return t('campaign_closed', 'Campaña cerrada');
    var d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5), m = Math.floor((ms % 36e5) / 6e4);
    return d > 0 ? d + ' d · ' + h + ' h' : h + ' h · ' + m + ' min';
  }
  /* La pieza en relieve lleva los segundos: es la que está viva. */
  function formatoPieza(ms) {
    var d = Math.floor(ms / 864e5), h = Math.floor((ms % 864e5) / 36e5);
    var m = Math.floor((ms % 36e5) / 6e4), s = Math.floor((ms % 6e4) / 1e3);
    return (d > 0 ? d + ' d · ' : '') + h + ' h · ' + dos(m) + ' min · ' + dos(s) + ' s';
  }
  function restante(iso) {
    var t = new Date(iso).getTime();
    return isNaN(t) ? null : t - Date.now();
  }

  var NOMBRE_ESTADO = {
    cerrada: t('state_closed', 'Cerrada'),
    en_produccion: t('state_production', 'En producción'),
    entregada: t('state_delivered', 'Entregada')
  };

  // ── La URL, letra a letra ─────────────────────────────────────
  function escribir(u, nuevo, alInstante) {
    clearTimeout(u.tecla);
    var el = u.path;
    if (!el) return;
    if (alInstante) { el.textContent = nuevo; u.win.classList.remove('kth--escribe'); return; }
    var base = '/collections/';
    u.win.classList.add('kth--escribe');
    (function paso() {
      var actual = el.textContent;
      if (actual !== nuevo.slice(0, actual.length) && actual.length > base.length) {
        el.textContent = actual.slice(0, -1);           // borrar hasta el tronco común
        u.tecla = setTimeout(paso, TECLA * 0.6);
      } else if (actual.length < nuevo.length) {
        el.textContent = nuevo.slice(0, actual.length + 1);
        u.tecla = setTimeout(paso, TECLA);
      } else {
        u.tecla = setTimeout(function () { u.win.classList.remove('kth--escribe'); }, 900);
      }
    })();
  }

  // ── Reloj y piezas según la tienda en pantalla ────────────────
  function reloj(u) {
    var s = u.skins[u.i];
    if (!s) return;
    var e = s.getAttribute('data-estado');
    var iso = s.getAttribute('data-cierre');
    var ms = iso ? restante(iso) : null;

    if (e === 'activa' && ms !== null && ms > 0) {
      u.relEt.textContent = t('closes_in', 'Cierra en');
      u.relV.textContent = formatoPieza(ms);
      u.relS.textContent = t('campaign_closing', 'Cierre de campaña') + ' · ' + s.getAttribute('data-cierre-txt');
    } else if (e === 'activa') {
      u.relEt.textContent = t('buy_window', 'Ventana de compra');
      u.relV.textContent = t('state_open', 'Abierta');
      u.relS.textContent = t('order_before_close', 'Pide antes del cierre');
    } else if (e === 'proximamente') {
      var abre = s.getAttribute('data-abre-txt');
      u.relEt.textContent = t('buy_window', 'Ventana de compra');
      u.relV.textContent = abre ? t('opens_on', 'Abre el') + ' ' + abre : t('opens_soon', 'Abre pronto');
      u.relS.textContent = t('store_visible', 'La tienda ya se puede ver');
    } else {
      u.relEt.textContent = t('buy_window', 'Ventana de compra');
      u.relV.textContent = NOMBRE_ESTADO[e] || t('state_closed', 'Cerrada');
      u.relS.textContent = t('store_visible_no_buy', 'La tienda sigue visible, sin compra');
    }

    // Las cuentas atrás dentro de las tiendas, con el formato real.
    u.cds.forEach(function (b) {
      var r = restante(b.getAttribute('data-kth-cd'));
      if (r !== null) b.textContent = formatoTienda(r);
    });
  }

  function poner(u, i, alInstante) {
    var n = u.skins.length;
    i = ((i % n) + n) % n;
    u.i = i;
    var s = u.skins[i];
    u.skins.forEach(function (k, j) { k.classList.toggle('is-on', j === i); });
    u.chips.forEach(function (c, j) { c.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });

    u.root.style.setProperty('--kth-a', s.getAttribute('data-a'));
    u.root.style.setProperty('--kth-b', s.getAttribute('data-b'));
    escribir(u, '/collections/' + s.getAttribute('data-handle'), alInstante || reduce.matches);

    var abierta = s.getAttribute('data-estado') === 'activa';
    u.win.classList.toggle('kth--abierta', abierta);
    if (u.pedido) u.pedido.textContent = s.getAttribute('data-pedido');
    reloj(u);

    if (u.cta) u.cta.setAttribute('href', s.getAttribute('data-url'));
    if (u.ctaN) u.ctaN.textContent = s.getAttribute('data-nombre');
  }

  // ── Paso automático ───────────────────────────────────────────
  function barra(u) {
    if (u.anim) { u.anim.cancel(); u.anim = null; }
    var c = u.chips[u.i];
    var b = c && c.querySelector('.kth__chip-bar');
    if (!b || !b.animate) return;
    u.anim = b.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: CADENCIA, easing: 'linear', fill: 'forwards' });
  }

  function programar(u) {
    clearTimeout(u.timer);
    var puede = u.auto && u.visible && !u.encima && !u.foco;
    u.root.classList.toggle('kth--auto', puede);
    if (!puede) { if (u.anim) { u.anim.cancel(); u.anim = null; } return; }
    barra(u);
    u.timer = setTimeout(function () {
      u.pasos++;
      poner(u, u.i + 1);
      // Una vuelta completa y se para en el primero.
      if (u.pasos >= u.skins.length) parar(u);
      else programar(u);
    }, CADENCIA);
  }

  function parar(u) {
    u.auto = false;
    programar(u);
  }

  // ── Foco desde las ventajas ───────────────────────────────────
  function enfocar(u, li) {
    clearInterval(u.ciclo);
    if (u.foco) u.foco.classList.remove('is-on');
    u.foco = li;
    if (!li) {
      u.win.removeAttribute('data-focus');
      programar(u);
      return;
    }
    var z = li.getAttribute('data-kth-feat');
    li.classList.add('is-on');
    u.win.setAttribute('data-focus', z);
    programar(u);

    /* La ventana de compra y el pedido se explican con una tienda abierta:
       si la de pantalla está cerrada, se pasa a una abierta. */
    if ((z === 'ventana' || z === 'pedidos') && u.skins[u.i].getAttribute('data-estado') !== 'activa') {
      for (var k = 0; k < u.skins.length; k++) {
        if (u.skins[k].getAttribute('data-estado') === 'activa') { poner(u, k); break; }
      }
    }
    // El diseño se explica cambiando de club.
    if (z === 'diseno' && u.skins.length > 1) {
      poner(u, u.i + 1);
      u.ciclo = setInterval(function () { poner(u, u.i + 1); }, CADENCIA_FOCO);
    }
  }

  function setup(root) {
    if (root.getAttribute('data-kth-ok')) return;
    var win = root.querySelector('[data-kth-win]');
    var skins = Array.prototype.slice.call(root.querySelectorAll('[data-kth-skin]'));
    if (!win || !skins.length) return;
    root.setAttribute('data-kth-ok', '1');

    var u = {
      root: root, win: win, skins: skins, i: 0,
      chips: Array.prototype.slice.call(root.querySelectorAll('[data-kth-chip]')),
      feats: Array.prototype.slice.call(root.querySelectorAll('[data-kth-feat]')),
      stage: root.querySelector('[data-k3d-stage]'),
      path: root.querySelector('[data-kth-path]'),
      relEt: root.querySelector('[data-kth-reloj-et]'),
      relV: root.querySelector('[data-kth-reloj-v]'),
      relS: root.querySelector('[data-kth-reloj-s]'),
      pedido: root.querySelector('[data-kth-pedido-s]'),
      cta: root.querySelector('[data-kth-cta]'),
      ctaN: root.querySelector('[data-kth-cta-n]'),
      cds: Array.prototype.slice.call(root.querySelectorAll('[data-kth-cd]')),
      auto: !reduce.matches && skins.length > 1,
      visible: false, encima: false, foco: null, pasos: 0,
      timer: 0, ciclo: 0, tecla: 0, anim: null
    };

    poner(u, 0, true);
    setInterval(function () { reloj(u); }, 1000);

    u.chips.forEach(function (c, j) {
      c.addEventListener('click', function () {
        parar(u);
        poner(u, j);
      });
    });

    u.feats.forEach(function (li) {
      li.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') enfocar(u, li); });
      li.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') enfocar(u, null); });
      li.addEventListener('click', function () { if (!fine.matches) enfocar(u, u.foco === li ? null : li); });
    });

    // Con el ratón sobre la ventana, se para a mirar.
    if (u.stage) {
      u.stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { u.encima = true; programar(u); } });
      u.stage.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { u.encima = false; programar(u); } });
    }

    if (u.auto && 'IntersectionObserver' in window && u.stage) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          u.enVista = en.isIntersecting && en.intersectionRatio >= 0.5;
          u.visible = u.enVista && !document.hidden;
          programar(u);
        });
      }, { threshold: [0, 0.5, 1] }).observe(u.stage);
    }

    // Pestaña en segundo plano: ni paso automático ni barra.
    document.addEventListener('visibilitychange', function () {
      u.visible = !!u.enVista && !document.hidden;
      programar(u);
    });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kth]'), setup);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
